'use client';
import Link from 'next/link';
import { Container, Stack, Title, Text, Anchor } from '@mantine/core';
import useSafeTranslation from '@/hooks/useSafeTranslation';

export default function Home() {
  const { tSafe: t } = useSafeTranslation();
  return (
    <Container size="sm" py="xl">
      <Stack gap="md">
        <Title order={1}>{t('appTitle')}</Title>
        <Text>{t('homeIntro')}</Text>
        <Anchor component={Link} href="/trips/pacto">
          {t('irAViajes')}
        </Anchor>
      </Stack>
    </Container>
  );
}
